
// Import all bank logos
const bankLogos = {
  // Public Sector Banks
  sbi: '/images/banks/sbi.png',
  pnb: '/images/banks/pnb.png',
  bob: '/images/banks/bob.png.png',  // Fixed: Added .png extension
  canara: '/images/banks/canara.png',
  boi: '/images/banks/boi.png',
  union: '/images/banks/union.png',
  iob: '/images/banks/iob.png',
  bom: '/images/banks/bom.png',
  
  // Private Sector Banks
  hdfc: '/images/banks/hdfc.png',
  icici: '/images/banks/icici.png',
  axis: '/images/banks/axis.png',
  kotak: '/images/banks/kotak.png',
  indusind: '/images/banks/indusind.png',
  idfc: '/images/banks/idfc.png',
  yes: '/images/banks/yesbank.png',  // Fixed: Corrected filename to yesbank.png
  bandhan: '/images/banks/bandhan.png.png',  // Fixed: Added .png extension
  federal: '/images/banks/federal.png',
  southindian: '/images/banks/southindian.png',
  karur: '/images/banks/karur.png'  // Note: karur.png is missing from the directory
};

// All banks in a single list
const allBanks = [
  { 
    name: "SBI",
    logo: bankLogos.sbi,
    bgColor: '#1E3A8A',
    className: "p-1.5"
  },
  { 
    name: "Punjab National Bank",
    logo: bankLogos.pnb,
    bgColor: '#1E3A8A',
    className: "p-1.5"
  },
  { 
    name: "Bank of Baroda",
    logo: bankLogos.bob,
    bgColor: '#1E40AF',
    className: "p-1.5"
  },
  { 
    name: "Canara Bank",
    logo: bankLogos.canara,
    bgColor: '#1E4ED8',
    className: "p-1.5"
  },
  { 
    name: "Bank of India",
    logo: bankLogos.boi,
    bgColor: '#3B82F6',
    className: "p-1.5"
  },
  { 
    name: "Union Bank of India",
    logo: bankLogos.union,
    bgColor: '#1E40AF',
    className: "p-1.5"
  },
  { 
    name: "Indian Overseas Bank",
    logo: bankLogos.iob,
    bgColor: '#1E3A8A',
    className: "p-1.5"
  },
  { 
    name: "Bank of Maharashtra",
    logo: bankLogos.bom,
    bgColor: '#1E4ED8',
    className: "p-1.5"
  },
  { 
    name: "HDFC Bank",
    logo: bankLogos.hdfc,
    bgColor: '#1E40AF',
    className: "p-1.5"
  },
  { 
    name: "ICICI Bank",
    logo: bankLogos.icici,
    bgColor: '#1E4ED8',
    className: "p-1.5"
  },
  { 
    name: "Axis Bank",
    logo: bankLogos.axis,
    bgColor: '#3B82F6',
    className: "p-2"
  },
  { 
    name: "Kotak Mahindra",
    logo: bankLogos.kotak,
    bgColor: '#1E40AF',
    className: "p-1.5"
  },
  { 
    name: "IndusInd Bank",
    logo: bankLogos.indusind,
    bgColor: '#1E40AF',
    className: "p-1.5"
  },
  { 
    name: "IDFC First Bank",
    logo: bankLogos.idfc,
    bgColor: '#1E4ED8',
    className: "p-1.5"
  },
  { 
    name: "Yes Bank",
    logo: bankLogos.yes,
    bgColor: '#3B82F6',
    className: "p-1.5"
  },
  { 
    name: "Bandhan Bank",
    logo: bankLogos.bandhan,
    bgColor: '#1E3A8A',
    className: "p-1.5"
  },
  { 
    name: "Federal Bank",
    logo: bankLogos.federal,
    bgColor: '#1E40AF',
    className: "p-1.5"
  },
  { 
    name: "South Indian Bank",
    logo: bankLogos.southindian,
    bgColor: '#1E4ED8',
    className: "p-1.5"
  },
  { 
    name: "Karur Vysya Bank",
    logo: bankLogos.karur,
    bgColor: '#3B82F6',
    className: "p-1.5"
  }
];

// Add this CSS animation for the marquee
export const PartnerBanks = () => {
  const marqueeStyle = `
    @keyframes marquee {
      0% { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }
    .animate-marquee {
      display: inline-flex;
      animation: marquee 60s linear infinite;
    }
    .animate-marquee:hover {
      animation-play-state: paused;
    }
  `;
  return (
    <>
      <style>{marqueeStyle}</style>
    <section className="py-16 px-4 bg-slate-900/50">
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-6">
          Our Partner Banks
        </h2>
        <p className="text-slate-300 text-center max-w-2xl mx-auto mb-12 text-sm md:text-base">
          We partner with India's leading banks to bring you the best loan options
        </p>
        
        {/* Enhanced Scrolling Bank Logos and Names Marquee */}
        <div className="w-full overflow-hidden bg-slate-800/30 mb-8 rounded-2xl py-8">
          <div className="flex items-center animate-marquee whitespace-nowrap">
            {[...allBanks, ...allBanks].map((bank, index) => (
              <div 
                key={`marquee-${index}`} 
                className="inline-flex flex-col items-center mx-10 min-w-[160px] group"
              >
                <div className="w-24 h-24 md:w-32 md:h-32 rounded-full bg-white/95 flex items-center justify-center mb-3 overflow-hidden p-3 shadow-lg transition-transform duration-300 group-hover:scale-110">
                  <img 
                    src={bank.logo} 
                    alt={`${bank.name} logo`}
                    className="w-full h-full object-contain"
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                      const parent = target.parentElement;
                      if (parent) {
                        const fallback = document.createElement('div');
                        fallback.className = 'w-full h-full rounded-full bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center';
                        fallback.innerHTML = `
                          <span class="text-white font-bold text-2xl">
                            ${bank.name.split(' ').map(word => word[0]).slice(0, 3).join('')}
                          </span>
                        `;
                        parent.appendChild(fallback);
                      }
                    }}
                  />
                </div>
                <span className="text-white text-base md:text-lg font-semibold mt-2 text-center">
                  {bank.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
    </>
  );
};
